<template>
  <div class="quick-nav-parent">
    <div class="quick-nav-child categories">
      <h2 class="quick-nav-title">Categories</h2>
<!-- If you want scroll style back just remove s-no-scroll and s-multiline      -->
      <div class="quick-nav s-scroll s-scroll-x s-no-scroll ">
        <div class="categories-parent s-flex-wrap">
          <a v-for="category in categories"
             :key="category.slug"
             :href="`/pulse/categories/${category.slug}`"
             class="s-badge s-badge-blog-category">
            {{ category.name }}
          </a>
        </div>
      </div>
    </div>

<!--    <div class="border-separator"/>-->

    <div class="quick-nav-child tags">
      <h2 class="quick-nav-title">Tags</h2>
<!-- If you want scroll style back just remove s-no-scroll and s-multiline      -->
      <div class="quick-nav s-scroll s-scroll-x s-no-scroll">
        <div class="categories-parent s-flex-wrap">
          <a v-for="tag in tags"
             :key="tag.slug"
             :href="`/pulse/tags/${tag.slug}`"
             class="s-badge s-badge-blog-tag">
            #{{ tag.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getAllCategories, getAllTags } from '#root/services/contentService'

const categories = ref([])
const tags = ref([])

onMounted(async () => {
  try {
    const [categoriesData, tagsData] = await Promise.all([
      getAllCategories(),
      getAllTags()
    ])

    categories.value = categoriesData
    tags.value = tagsData
  } catch (err) {
    console.error('Error fetching categories and tags:', err)
  }
})
</script>
